import BaseIcon, { getIconStyle } from './BaseIcon';
export { default as IconWithBadge } from './IconWithBadge';
export { BaseIcon, getIconStyle };
export default BaseIcon;